import { useState, useEffect } from 'react';

// Shared state across all components using this hook
let globalIsResyncing = false;
const listeners = new Set<() => void>();

const notifyListeners = () => {
  listeners.forEach(listener => listener());
};

/**
 * Custom hook to manage shared resync state across multiple components.
 * When one component starts resyncing, all components using this hook will show loading state.
 */
export const useResyncTrades = () => {
  const [isResyncing, setIsResyncing] = useState(globalIsResyncing);

  useEffect(() => {
    const updateState = () => {
      setIsResyncing(globalIsResyncing);
    };

    listeners.add(updateState);

    return () => {
      listeners.delete(updateState);
    };
  }, []);

  const setResyncing = (value: boolean) => {
    globalIsResyncing = value;
    notifyListeners();
  };

  return {
    isResyncing,
    setResyncing,
  };
};
